import { render } from "./OrgList.vue?vue&type=template&id=4caf1d6e&scoped=true"
import script from "./OrgList.vue?vue&type=script&lang=js"
export * from "./OrgList.vue?vue&type=script&lang=js"

import "./OrgList.vue?vue&type=style&index=0&id=4caf1d6e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4caf1d6e"]])

export default __exports__